import { useCheckoutFrameStore } from 'app/context/checkoutStore';
import { useErrorStore } from 'app/context/errorStore';
import { PAYMENT_STATUS } from 'app/util/constants';
import { logError } from 'app/util/errorsLoggerWrapper';
import { handleEvents, handleRedirect } from 'app/util/handleEvents';
import { CheckoutRequest } from 'common/interface';
import { useEffect } from 'react';
import { useIsEmbedded } from './useIsEmbedded';

export const useErrorHandler = () => {
  const { error, isLoading } = useErrorStore();
  const { checkoutRequest } = useCheckoutFrameStore();
  const { isEmbedded } = useIsEmbedded();

  useEffect(() => {
    if (!error) {
      return;
    }
    logError(error);
    if (isEmbedded) {
      handleEvents(PAYMENT_STATUS.failed, error);
      return;
    }
    const urlRedirect = getRedirectUrl(error, checkoutRequest);
    if (urlRedirect) {
      handleRedirect(urlRedirect);
    }
  }, [error, checkoutRequest]);

  return {
    error,
    isEmbedded,
    isLoading,
  };
};

const getRedirectUrl = (error: any, checkoutRequest?: CheckoutRequest): string | null => {
  const { urlRedirect } = error;
  if (urlRedirect) {
    return urlRedirect;
  }

  if (!checkoutRequest || !checkoutRequest.failureUrl) {
    return null;
  }

  const { id, orders, failureUrl } = checkoutRequest;
  const orderId = orders[0].apiOrderId;
  const url = new URL(failureUrl);

  url.searchParams.set('checkout_id', id);
  url.searchParams.set('order_id', orderId);
  url.searchParams.set('payment_status', 'error');

  return url.toString();
};
